import haloNewsletterPopup from "./haloNewsletterPopup";
import halohandleHomePage3Load from "./halohandleHomePage3Load";
import halohandleHomePage3Scroll from "./halohandleHomePage3Scroll";
import halohandleHomePage4Load from "./halohandleHomePage4Load";
import haloRecentlyBoughtPopup from "./haloRecentlyBoughtPopup";
import haloRecentlyViewedProduct from "./haloRecentlyViewedProduct";
import haloBeforeYouLeave from "./haloBeforeYouLeave";
import haloMegaMenuEditor from "./haloMegaMenuEditor";
import haloAjaxLoginPopup from "./haloAjaxLoginPopup";
import haloAddOptionForProduct from "./haloAddOptionForProduct";
import AZBrands from "./haloAZBrands";
import haloAjaxAddToCart from "./haloAjaxAddToCart";
import mobileMenuToggle from "../global/mobile-menu-toggle";
import quickSearch from "../global/quick-search";
import quickView from "../global/quick-view";
import menu from "../global/menu";
import privacyCookieNotification from "../global/cookieNotification";
import loadingProgressBar from "../global/loading-progress-bar";
import haloAskAnExpertPopup from './haloAskAnExpertPopup';
import { Fancybox } from "fancybox";

export default function (context) {
  const $context = context,
    theme_settings = context.themeSettings;

  const $header = $("header.header");

  var height_promotion = $(".halo-topHeader").outerHeight(),
    height_header = $header.outerHeight();

  if ($(".is-headerTransparent.page-type-default .header").length) {
    height_header = 0;
  }

  var scroll_position = $(window).scrollTop();

  var checkJS_load = true,
    check_sliderBrands = true,
    check_loadProductCarousel = true,
    check_loadProductGrid = true,
    check_imageGalleryFancyBox = true,
    check_homeImageInstagramCarousel = true,
    check_homeImageInstagram2Carousel = true,
    check_homeImageInstagram3Carousel = true;

  if ($("#haloAZBrandsTable").length) {
    AZBrands(context);
  }

  function loadFunction() {
    if (checkJS_load) {
      checkJS_load = false;

      haloRecentlyBoughtPopup($context);
      haloBeforeYouLeave($context);
      haloAjaxAddToCart($context);
      haloMegaMenuEditor($context);
      mobileMenuToggle();
      quickSearch($context);
      quickView($context);
      menu();
      privacyCookieNotification();
      loadingProgressBar();

      if (context.themeSettings.halo_ask_an_expert && context.themeSettings.halo_ask_an_expert_pagelink) haloAskAnExpertPopup(context);

      if (theme_settings.halo_recentProds) {
        haloRecentlyViewedProduct($context);
      }

      if (theme_settings.halo_newsletter_popup) {
        haloNewsletterPopup($context);
      }

      haloAjaxLoginPopup();
      searchFormMobile();
      activeMenuMobile();
      variantImageColor();
      footerMobileToggle();
      checkCookiesPopup();
      hoverMenu();
      lookbookSlider();
      countDownProduct(".card-countDown");
      halohandleHomePage3Load();
      halohandleHomePage4Load($context);
    }
  }

  function eventLoad() {
    $(document).ready(function () {
      const wWidth = window.innerWidth,
        tScroll = $(this).scrollTop();

      var productCarousel = $(".productCarousel"),
        showDotbars = productCarousel.data("dots-bar");

      activeFirstLoadPage();
      loadOptionForProductCarousel(tScroll);
      loadProductGrid(tScroll);
      imageGalleryFancyBox(tScroll);
      homeImageCarousel(tScroll);
      sliderBrands(tScroll);
      faqsToggle();
      blogTags();
      halofadeInUp(tScroll);
      activeDropdown();
      activeValueDropdownSearch();

      if (showDotbars) {
        productCarousel.each((index, element) => {
          var $prodWrapId = $(element).attr("id"),
            wrap = $(`#${$prodWrapId}`);
            
          if ($prodWrapId) {
            slickDots(wrap[0], wrap);
          }
        });
      }
    });

    $(window).on("scroll", (e) => {
      const $target = $(e.currentTarget);
      const tScroll = $target.scrollTop();
      halohandleHomePage3Scroll(tScroll);
      loadFunction();
      haloStickyHeader(tScroll);
      loadOptionForProductCarousel(tScroll);
      loadProductGrid(tScroll);
      imageGalleryFancyBox(tScroll);
      homeImageCarousel(tScroll);
      sliderBrands(tScroll);
      halofadeInUp(tScroll);
    });

    $(document).on("keydown mousemove touchstart", (e) => {
      loadFunction();
    });

    //
    // Resize
    // -----------------------------------------------------------------------------
    $(window).on("resize", (e) => {
      checkCookiesPopup();
      activeMenuMobile();
      searchFormMobile();
    });
  }
  eventLoad();

  function Event() {
    //
    // Change Option
    // // -----------------------------------------------------------------------------
    const btn_cardOption = ".card-option .form-option-swatch";

    $(document).on("click", btn_cardOption, (e) => {
      e.preventDefault();
      const $targer = $(e.currentTarget),
        thisTitle = $targer.find(".form-option-variant").attr("title");

      $(btn_cardOption).removeClass("is-active");
      $targer.addClass("is-active");
      $targer.parents(".card").find(".card-name").text(` - ${thisTitle}`);
    });

    //
    // Close
    // -----------------------------------------------------------------------------
    const $btn_close = $(".btn-close");
    const $btn_mobileMenu = $(".mobileMenu-toggle");
    const $beforeYouLeave = $("#before-you-leave");

    $btn_close.on("click", (e) => {
      e.preventDefault();
      const $target = $(e.currentTarget);

      $target.parents(".halo-side-block").removeClass("is-open");

      if ($("body").hasClass("openBeforeYouLeave")) {
        $("body").removeClass("openBeforeYouLeave");

        setTimeout(function () {
          $beforeYouLeave.hide();
        }, 200);
      } else {
        $("body").removeClass("is-side-block");

        setTimeout(function () {
          $sideLogin.hide();
          $sideCart.hide();
          $("#sideBlock_category").hide();
          $("#sideBlock_search").hide();
          $("#sideBlock_brand").hide();
          $("#sideBlock_blog").hide();
        }, 200);
      }

      if ($("body").hasClass("has-activeNavPages")) {
        $btn_mobileMenu.trigger("click");
      }
    });

    //
    // Login Form
    // -----------------------------------------------------------------------------
    if (!$("body").hasClass("page-type-login")) {
      $("[data-login-form]").on("click", (event) => {
        event.preventDefault();
        if ($(".halo-auth-sidebar").hasClass("is-open")) {
          $(".halo-auth-sidebar").removeClass("is-open");
          $("body").removeClass("openAuthSidebar");
        } else {
          $(".halo-auth-sidebar").addClass("is-open");
          $("body").addClass("openAuthSidebar");
        }
      });
    } else {
      $("[data-login-form]").on("click", (event) => {
        event.preventDefault();

        $("html, body").animate(
          {
            scrollTop: $(".login").offset().top,
          },
          700
        );
      });
    }

    //
    // Account Form
    // -----------------------------------------------------------------------------
    $(".halo-auth-sidebar .halo-sidebar-header .close").on("click", (event) => {
      event.preventDefault();

      $(".halo-auth-sidebar").removeClass("is-open");
      $("body").removeClass("openAuthSidebar");
    });

    $(document).on("click", (event) => {
      if ($(".halo-auth-sidebar").hasClass("is-open")) {
        if (
          $(event.target).closest(".halo-auth-sidebar").length === 0 &&
          $(event.target).closest("[data-login-form]").length === 0
        ) {
          $(".halo-auth-sidebar").removeClass("is-open");
          $("body").removeClass("openAuthSidebar");
        }
      }
    });

    //
    // Add To Wish List
    // -----------------------------------------------------------------------------
    $(document).on("click", ".card .wishlist", (e) => {
      e.preventDefault();
      var $this_wl = $(e.currentTarget);
      var url_awl = $this_wl.attr("href");

      if ($("body").hasClass("is-login")) {
        $.post(url_awl).done(function () {
          window.location.href = url_awl;
        });
      } else {
        window.location.href = "/login.php";
      }
    });

    //
    // Footer Info Heading Toggle
    // -----------------------------------------------------------------------------
    const $footerHeadingToggle = $(".footer-info-heading--toggle");

    $footerHeadingToggle.on("click", (e) => {
      e.preventDefault();
      const wWidth = window.innerWidth;

      if (wWidth < 768) {
        const $target = $(e.currentTarget);
        const $thisFooterInfo = $target.parents(".footer-info-col");
        const $thisFooterInfo_list = $thisFooterInfo.find(".footer-info-list");

        $thisFooterInfo.toggleClass("open-dropdown");

        if ($thisFooterInfo.hasClass("open-dropdown")) {
          $thisFooterInfo_list.slideDown(400);
        } else {
          $thisFooterInfo_list.slideUp(400);
        }
      }
    });
  }
  Event();
  function activeFirstLoadPage() {
    let item = window.localStorage.getItem("isLoadedSite");
    let elemLoad = document.getElementById("loadfirstpage");
    if (elemLoad) {
      let currentMonth = new Date().getMonth();
      let monthStorage = new Date(
        window.localStorage.timeLoadedSite
      ).getMonth();

      if (item) {
        if (currentMonth != monthStorage) {
          activeLoadPage();
        } else {
          window.localStorage.setItem("timeLoadedSite", new Date());
        }
      } else {
        activeLoadPage();
      }
    }
  }
  function activeValueDropdownSearch() {
    let dropdown = document.querySelector("#quickSearch .dropdown-section");
    if (dropdown) {
      let buttonDropdown = dropdown.querySelector(".button-dropdown");
      let inputDropdown = dropdown.querySelector(".value-dropdown");

      const urlSearchParams = new URLSearchParams(window.location.search);
      let params = Object.fromEntries(urlSearchParams.entries());
      if (params.category) {
        let elemCate = dropdown.querySelector(`li[value="${params.category}"]`);
        if (elemCate) {
          inputDropdown.value = params.category;
          buttonDropdown.querySelector(".text").innerHTML =
            elemCate.querySelector("p").innerHTML;
        }
      }
    }
  }

  function activeDropdown() {
    let allDropdown = document.querySelectorAll(
      ".dropdown-section:not(.redirect)"
    );
    allDropdown.forEach((dropdown) => {
      let button = dropdown.querySelector(".button");
      let listDropdownItem = dropdown.querySelectorAll(
        ".dropdown-section-menu ul li"
      );
      let valueDropdown = dropdown.querySelector(".value-dropdown");

      button.onclick = (e) => {
        dropdown.classList.toggle("is-active");
        e.preventDefault();
      };

      listDropdownItem.forEach((item) => {
        item.onclick = function () {
          let value = item.getAttribute("value");
          valueDropdown.setAttribute("value", value);
          dropdown.classList.remove("is-active");
          button.querySelector(".text").innerHTML =
            item.querySelector("p").innerHTML;
        };
      });
      button.addEventListener("focusout", () => {
        setTimeout(() => {
          dropdown.classList.toggle("is-active");
        }, 100);
      });
    });
  }
  function activeLoadPage() {
    let elemLoad = document.getElementById("loadfirstpage");
    elemLoad.classList.add("is-active");
    setTimeout(() => {
      elemLoad.classList.add("view-out");
    }, 1000);
    window.localStorage.setItem("isLoadedSite", true);
    window.localStorage.setItem("timeLoadedSite", new Date());
    setTimeout(() => {
      elemLoad.classList.remove("is-active");
    }, 2000);
  }
  function countDownProduct(selector) {
    setInterval(() => {
      let listCountDown = document.querySelectorAll(selector);

      listCountDown.forEach((elem) => {
        if (!elem.innerHTML.trim()) {
          let countDown = elem.getAttribute("data-countdown");
          let countDownDate = new Date(countDown).getTime();
          let countDownFunction = setInterval(function () {
            let now = new Date().getTime(),
              distance = countDownDate - now;

            if (distance < 0) {
              clearInterval(countDownFunction);
            } else {
              let days = Math.floor(distance / (1000 * 60 * 60 * 24));
              let hours = Math.floor(
                (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
              );
              let minutes = Math.floor(
                (distance % (1000 * 60 * 60)) / (1000 * 60)
              );
              let seconds = Math.floor((distance % (1000 * 60)) / 1000);
              if (days < 10) {
                days = "0" + days.toString();
              }
              if (hours < 10) {
                hours = "0" + hours.toString();
              }
              if (minutes < 10) {
                minutes = "0" + minutes.toString();
              }
              if (seconds < 10) {
                seconds = "0" + seconds.toString();
              }
              let strCountDown =
                '<span class="num">' +
                days +
                'D :</span> <span class="num">' +
                hours +
                ' :</span> <span class="num">' +
                minutes +
                ' :</span> <span class="num">' +
                seconds +
                "</span>";
              elem.classList.add("is-active");
              elem.innerHTML = strCountDown;
            }
          }, 1000);
        }
      });
    }, 1000);
  }

  function hoverMenu() {
    if ($(window).width() > 1024) {
      if (
        $(
          ".navPages-list:not(.navPages-list--user) > .navPages-item.has-dropdown"
        ).length
      ) {
        $(
          ".navPages-list:not(.navPages-list--user) > .navPages-item.has-dropdown"
        )
          .on("mouseover", (event) => {
            $("body").addClass("openMenuPC");
          })
          .on("mouseleave", (event) => {
            $("body").removeClass("openMenuPC");
          });
      }
    }
  }

  function searchFormMobile() {
    if (context.themeSettings.halo_homepage_layout_3) {
      if ($(".halo-bottomHeader #quickSearch").length) {
        $(".halo-bottomHeader #quickSearch").appendTo(
          "#halo-search-sidebar .halo-sidebar-search"
        );
      }
    } else {
      if ($(window).width() < 1025) {
        if ($(".halo-bottomHeader #quickSearch").length) {
          $(".halo-bottomHeader #quickSearch").appendTo(
            "#halo-search-sidebar .halo-sidebar-search"
          );
        }
      } else {
        if (!$(".item--quicksearch #quickSearch").length) {
          $("#halo-search-sidebar #quickSearch").appendTo(".item--quicksearch");
        }
      }
    }
  }

  function activeMenuMobile() {
    $(".halo-menu-sidebar .halo-sidebar-close").on("click", (event) => {
      event.preventDefault();

      if ($("body").hasClass("has-activeNavPages")) {
        $(".mobileMenu-toggle").trigger("click");
      }
    });

    $(document).on("click", (event) => {
      if ($("body").hasClass("has-activeNavPages")) {
        if (
          $(event.target).closest(".halo-menu-sidebar").length === 0 &&
          $(event.target).closest(".mobileMenu-toggle").length === 0
        ) {
          $(".mobileMenu-toggle").trigger("click");
        }
      }
    });

    var $menuPc = $(
        ".halo-bottomHeader .navPages-list:not(.navPages-list--user)"
      ),
      $menuMobile = $(
        "#halo-menu-sidebar .navPages-list:not(.navPages-list--user)"
      );

    if ($(window).width() <= 1024) {
      $(".mobileMenu-toggle").on("click", (event) => {
        if ($menuPc.length) {
          if (!$menuMobile.children().length) {
            $menuPc.children().appendTo($menuMobile);
          }
        }
      });
    }
  }

  function variantImageColor() {
    $(document).on("click", ".card .card-option .form-option", function () {
      var self = $(this),
        newImageVariant = self.data("image"),
        productItemElm = self.closest(".card"),
        variantTitle = self.data("title");

      productItemElm.find(".variant_color_name").html(variantTitle);
      self.parents(".card-option").find(".form-option").removeClass("active");
      self.addClass("active");
      if (newImageVariant != "undefined") {
        productItemElm.find(".card-img-container img").attr({
          src: newImageVariant,
          srcset: newImageVariant,
        });
        return false;
      }
    });
  }

  function footerMobileToggle() {
    $(".footer-info-col--mobile .footer-info-heading").on("click", (event) => {
      $(".footer-info-col--mobile .footer-info-heading")
        .not($(event.currentTarget))
        .removeClass("is-clicked");

      if ($(event.currentTarget).hasClass("is-clicked")) {
        $(event.currentTarget).removeClass("is-clicked");
      } else {
        $(event.currentTarget).addClass("is-clicked");
      }

      $(".footer-info-col--mobile").each((index, element) => {
        if ($(".footer-info-heading", element).hasClass("is-clicked")) {
          $(element).find(".footer-info-wrapper").slideDown("slow");
        } else {
          $(element).find(".footer-info-wrapper").slideUp("slow");
        }
      });
    });
  }

  function checkCookiesPopup() {
    if ($("#consent-manager").length) {
      var height = $("#consent-manager").height() + 15;

      $("body").css("padding-bottom", height);

      if ($(window).width() > 1024) {
        if ($("body").hasClass("page-type-category")) {
          $(".compare-link").css(
            "bottom",
            height + $(".halo-ask-an-expert-btn").height() - 10
          );
        }
      }
      if ($(window).width() > 767) {
        if (!$("body").hasClass("page-type-product")) {
          $(".halo-ask-an-expert-btn").css("bottom", height);
        }
      }
      $("#halo-recently-bought-popup").css("bottom", height);
    }
    if ($("#consent-manager-update-banner").length) {
      var height = $("#consent-manager-update-banner").height() + 15;

      $("body").css("padding-bottom", height);

      if ($(window).width() > 1024) {
        if ($("body").hasClass("page-type-category")) {
          $(".compare-link").css(
            "bottom",
            height + $(".halo-ask-an-expert-btn").height() - 10
          );
        }
      }
      if ($(window).width() > 767) {
        if (!$("body").hasClass("page-type-product")) {
          $(".halo-ask-an-expert-btn").css("bottom", height);
        }
      }
      $("#halo-recently-bought-popup").css("bottom", height);
    }
  }

  function haloStickyHeader(tScroll) {
    if (theme_settings.halo_headerSticky) {
      if (tScroll > height_promotion && tScroll < scroll_position) {
        if ($(window).width() > 1024) {
          if ($(".halo-search-sticky").length) {
            $(".halo-search-main #quickSearch").appendTo(".halo-search-sticky");
          }
        }
        if (!$(".header-height").length) {
          $header.before(
            '<div class="header-height" style="height: ' +
              height_header +
              'px"></div>'
          );
        }
        $header.addClass("is-sticky");
        $header.css("animation-name", "fadeInDown");
      } else {
        if ($(".halo-search-main").length) {
          $(".halo-search-sticky #quickSearch").appendTo(".halo-search-main");
        }
        $header.removeClass("is-sticky");
        $(".header-height").remove();
        $header.css("animation-name", "");
      }

      scroll_position = tScroll;
    }
  }

  function loadOptionForProductCarousel(tScroll) {
    const $loadProductCarousel = $(".productCarousel");

    if ($loadProductCarousel.length) {
      const $loadProductCarouselTop =
        $loadProductCarousel.offset().top - screen.height;

      if (tScroll > $loadProductCarouselTop && check_loadProductCarousel) {
        check_loadProductCarousel = false;

        if ($(".productCarousel").length > 0) {
          $(".productCarousel").each((index, element) => {
            var $prodWrapId = $(element).attr("id");

            haloAddOptionForProduct($context, $prodWrapId);
          });
        }
      }
    }
  }

  function loadProductGrid(tScroll) {
    const $loadProductGrid = $(".productGrid:not(.productListing)");

    if ($loadProductGrid.length) {
      const $loadProductGridTop = $loadProductGrid.offset().top - screen.height;

      if (tScroll > $loadProductGridTop && check_loadProductGrid) {
        check_loadProductGrid = false;

        if ($(".productGrid:not(.productListing)").length > 0) {
          let col = context.themeSettings.homeProd_col_1;
          if (screen.width >= 551 && screen.width <= 1024) {
            if (context.themeSettings.homeProd_col_tablet > 0) {
              col = context.themeSettings.homeProd_col_tablet;
            }
          }
          if (screen.width <= 550) {

            if (context.themeSettings.homeProd_col_mobile > 0) {
              col = context.themeSettings.homeProd_col_mobile;
            }
          }
          const limitProduct = 2 * parseInt(col);

          $(".productGrid:not(.productListing)").each((index, element) => {
            var $prodWrapId = $(element).attr("id");

            $(element).find(".product:visible").css("display", "none");
            $(element)
              .find(".product:hidden")
              .slice(0, limitProduct)
              .css("display", "inline-block");

            if ($(element).find(".product").length > limitProduct) {
              $(element).after(
                '<div class="productGrid-showMore"> <a class="button button--primary" href="#" data-href="' +
                  $prodWrapId +
                  '"><svg class="icon down" role="img" aria-label="Icon Arrow Down"><title>Icon Arrow Down</title> <desc>Icon Arrow Down</desc><use xlink:href="#icon-chevron-down"></use> </svg> View more</a></div>'
              );
            }

            haloAddOptionForProduct($context, $prodWrapId);
          });

          $(".productGrid-showMore .button").on("click", (event) => {
            event.preventDefault();
            var target = $(event.currentTarget),
              targetId = target.data("href");

            target.blur();

            $("[data-block=" + targetId + "]")
              .find(".product:hidden")
              .slice(0, limitProduct)
              .css("display", "inline-block");

            if (
              $("[data-block=" + targetId + "]").find(".product:hidden")
                .length == 0
            ) {
              target.addClass("disable").text("No more items");
            }
          });
        }
      }
    }
  }

  function imageGalleryFancyBox(tScroll) {
    const $imageGalleryFancyBox = $(".halo-instagram-gallery");

    if ($imageGalleryFancyBox.length) {
      const $imageGalleryFancyBoxTop =
        $imageGalleryFancyBox.offset().top - screen.height;

      if (tScroll > $imageGalleryFancyBoxTop && check_imageGalleryFancyBox) {
        check_imageGalleryFancyBox = false;

        if ($(".halo-instagram-gallery").length > 0) {
          var $imageInstaRow = $(".halo-instagram-gallery").find(
            ".halo-image-instagram"
          );
          fancyBoxImage($imageInstaRow.find("[data-fancybox]"));
        }
        function fancyBoxImage($image) {
          Fancybox.bind('[data-fancybox="instagram_image"]', {
            infinite: true,
          });
        }
      }
    }
  }

  function slickDots(wrap, productCarousel) {
    const slickDots = wrap.querySelectorAll(".slick-dots li");
    const totalSlideStepCount = slickDots.length;
    const dotbars = wrap.parentElement.querySelector("[data-bars]");
    const dots = wrap.querySelector(".slick-dots");
    const barThumb = dotbars.querySelector(".bar-thumb");
    const barThumbWidth = dotbars.clientWidth / totalSlideStepCount;
    barThumb.style.width = `calc(100%/${totalSlideStepCount})`;
    const dotsBarLeft = dotbars.getBoundingClientRect().x;

    if (slickDots.length === 0) {
      dotbars.remove();
      return;
    }

    productCarousel.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        const slickDots = wrap.querySelectorAll(".slick-dots li");
        const totalSlideStepCount = slickDots.length;
        const dotsActive = dots.querySelector(".slick-active").dataset.index;

        if (totalSlideStepCount == dotsActive) {
          barThumb.style.left = "0";
        } else {
          barThumb.style.left = `calc(100%/${totalSlideStepCount} * ${dotsActive})`;
        }
      }
    );

    dotbars.addEventListener("click", (e) => {
      const clickedIndex = Math.floor((e.pageX - dotsBarLeft) / barThumbWidth);
      slickDots[clickedIndex].click();
    });
  }

  function homeImageCarousel(tScroll) {
    const $homeImageInstagramCarousel = $(
        "#halo_instagram .halo-image-instagram"
      ),
      $homeImageInstagram2Carousel = $(
        "#halo_instagram_2 .halo-image-instagram"
      ),
      $homeImageInstagram3Carousel = $(
        "#halo_instagram_3 .halo-image-instagram"
      );

    if ($homeImageInstagramCarousel.length) {
      const $homeImageInstagramCarouselTop =
        $homeImageInstagramCarousel.offset().top - screen.height;

      if (
        tScroll > $homeImageInstagramCarouselTop &&
        check_homeImageInstagramCarousel
      ) {
        check_homeImageInstagramCarousel = false;

        $homeImageInstagramCarousel.slick({
          dots: false,
          arrows: true,
          infinite: true,
          mobileFirst: true,
          autoplay: false,
          slidesToShow: 2,
          slidesToScroll: 2,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              },
            },
            {
              breakpoint: 550,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }
          ]
        });
      }
    }

    if ($homeImageInstagram2Carousel.length) {
      const $homeImageInstagram2CarouselTop =
        $homeImageInstagram2Carousel.offset().top - screen.height;

      if (
        tScroll > $homeImageInstagram2CarouselTop &&
        check_homeImageInstagram2Carousel
      ) {
        check_homeImageInstagram2Carousel = false;

        $homeImageInstagram2Carousel.slick({
          dots: false,
          arrows: false,
          infinite: true,
          mobileFirst: true,
          autoplay: false,
          slidesToShow: 2,
          slidesToScroll: 2,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 3
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: true
              },
            },
            {
              breakpoint: 551,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: true
              },
            },
            {
              breakpoint: 10,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: true
              }
            }
          ]
        });
      }
    }
    if ($homeImageInstagram3Carousel.length) {
      const $homeImageInstagram3CarouselTop =
        $homeImageInstagram3Carousel.offset().top - screen.height;

      if (
        tScroll > $homeImageInstagram3CarouselTop &&
        check_homeImageInstagram3Carousel
      ) {
        check_homeImageInstagram3Carousel = false;

        $homeImageInstagram3Carousel.slick({
          dots: true,
          arrows: false,
          infinite: true,
          mobileFirst: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: false
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: true
              },
            },
            {
              breakpoint: 551,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: true
              }
            }
          ]
        });
      }
    }
  }

  function sliderBrands(tScroll) {
    const $brandsCarousel = $(".haloBrandsSlider .haloBrandsSlider__carousel");

    if ($brandsCarousel.length) {
      const brandsCarousel_top = $brandsCarousel.offset().top - screen.height;

      if (tScroll > brandsCarousel_top && check_sliderBrands) {
        check_sliderBrands = false;

        $brandsCarousel.slick({
          dots: false,
          arrows: true,
          infinite: true,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 400,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              },
            },
            {
              breakpoint: 551,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5
              }
            }
          ]
        });
      }
    }
  }

  function blogTags() {
    if ($("#blog-tags").length > 0) {
      if ($('body[data-page-type="blog"]').length) {
        let arr = {};

        $("#blog-tags .recentPosts_tags [data-tag]").each(function (i) {
          var txt = $(this).data("tag");

          if (arr[txt]) {
            $(this).remove();
          } else {
            arr[txt] = true;
          }
        });

        $("#blog-tags .recentPosts_tags").show();
      } else if ($('body[data-page-type="blog_post"]').length) {
        const url_blogTags = "/blog";

        $.get(url_blogTags, function (data) {
          let arr = {};
          const response = $(data).find("#blog-tags .recentPosts_tags").html();

          $("#blog-tags .recentPosts_tags").html(response);

          $("#blog-tags .recentPosts_tags [data-tag]").each(function (i) {
            var txt = $(this).data("tag");

            if (arr[txt]) {
              $(this).remove();
            } else {
              arr[txt] = true;
            }
          });

          $("#blog-tags .recentPosts_tags").show();
        });
      }
    }
  }

  function faqsToggle() {
    if ($(".page--faqs").length > 0) {
      $(".faq-desc").appendTo(".halo-faqs-sidebar .haloFaqs-header__des");

      $(".page-normal .card .title").on("click", (event) => {
        event.preventDefault();

        var target = $(event.currentTarget);

        $(".page-normal .card .title").not(target).removeClass("collapsed");

        if (target.hasClass("collapsed")) {
          target.removeClass("collapsed");
          target.parents(".card").css("border-bottom-color", "#e6e6e6");
        } else {
          target.addClass("collapsed");
          target.parents(".card").css("border-bottom-color", "none");
        }

        $(".page-normal .card").each((index, element) => {
          if ($(".title", element).hasClass("collapsed")) {
            $(element).find(".collapse").slideDown("slow");
          } else {
            $(element).find(".collapse").slideUp("slow");
          }
        });
      });
    }
  }

  function lookbookSlider() {
    if ($("#halo-lookbook-slider").length > 0) {
      var $block = $("#halo-lookbook-slider"),
        wrap = $block.find(".halo-lookbook-slider");

      slickCarousel(wrap);

      function slickCarousel(wrap) {
        if (wrap.length > 0) {
          wrap.slick({
            dots: true,
            arrows: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            infinite: true,
            fade: true,
            responsive: [
              {
                breakpoint: 1025,
                settings: {
                  dots: false,
                  arrows: true
                }
              }
            ]
          });
        }
      }
    }
  }
  function halofadeInUp(tScroll) {
    const $haloBlock = $(".halo-fadeInUp");

    if ($haloBlock.length) {
      $haloBlock.each(function (i) {
        const $haloBlockTop =
          $haloBlock.eq(i).offset().top - screen.height + 100;
        const $haloBlockBottom =
          $haloBlock.eq(i).offset().top + screen.height - 100;
        var img = $haloBlock.eq(i).find("img");

        if (tScroll < $haloBlockBottom && tScroll > $haloBlockTop) {
          $haloBlock.eq(i).addClass("animated");
        }
      });
    }
  }
}
